var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0c8.836 0 16 7.163 16 16s-7.164 16-16 16S0 24.837 0 16 7.164 0 16 0zM9.534 5.849h-.325c-.355.036-.68.19-.933.443l-1.18 1.18a4.282 4.282 0 00-1.25 3.152c.026 1.197.507 2.36 1.25 3.29 1.62 2.026 3.27 4.044 5.105 5.88 1.836 1.837 3.854 3.487 5.88 5.106.933.746 2.101 1.23 3.303 1.25l.083.002a4.309 4.309 0 003.075-1.27l1.162-1.163a1.55 1.55 0 000-2.19l-2.409-2.408a1.533 1.533 0 00-1.095-.452c-.414 0-.802.159-1.095.452l-1.269 1.269-.392-.124a.967.967 0 01-.267-.136c-.82-.584-1.646-1.168-2.444-1.782a16.923 16.923 0 01-1.655-1.43 16.92 16.92 0 01-1.43-1.656c-.614-.797-1.198-1.623-1.782-2.443a.984.984 0 01-.133-.257l-.132-.397 1.274-1.274c.293-.294.452-.68.452-1.095 0-.415-.159-.802-.452-1.095l-2.409-2.409a1.528 1.528 0 00-.932-.443z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgPhone;